import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "getaroundCircle"
const GetaroundCircleIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M16.044 6.012C16.067 6.012 16.09 6.017 16.122 6.02 16.122 6.056 16.13 6.09 16.122 6.119 15.944 6.746 15.6 7.25 15.006 7.557 14.911 7.607 14.79 7.635 14.68 7.636 13.73 7.642 12.779 7.66 11.828 7.634 10.264 7.59 9.644 8.836 9.689 9.869 9.714 10.418 9.884 10.908 10.254 11.328 11.014 12.188 13.02 12.215 13.52 10.506 13.76 9.695 13.623 8.942 13.071 8.28L12.997 8.177C13.293 8.177 13.555 8.177 13.813 8.18 14.194 8.18 14.574 8.186 14.954 8.177 15.088 8.174 15.144 8.222 15.189 8.34 15.722 9.757 15.443 11.61 14.194 12.675 14.186 12.682 14.18 12.695 14.172 12.705 14.34 12.838 14.52 12.96 14.679 13.105 15.204 13.58 15.42 14.192 15.441 14.885 15.476 16.046 15.083 17.009 14.109 17.693 13.62 18.035 13.068 18.229 12.479 18.314 11.48 18.455 10.511 18.368 9.606 17.892 8.615 17.37 8.045 16.552 7.897 15.42L9.73 15.223 9.764 15.367C9.867 15.777 10.1 16.094 10.464 16.306 11.213 16.739 11.992 16.765 12.763 16.393 13.455 16.061 13.76 15.261 13.496 14.555 13.309 14.061 12.915 13.793 12.429 13.662 12.167 13.59 11.886 13.562 11.612 13.554 10.743 13.53 9.937 13.32 9.245 12.776 8.481 12.174 8.065 11.37 7.926 10.421 7.798 9.54 7.9 8.69 8.328 7.902 8.99 6.682 10.053 6.056 11.428 6.021 12.966 5.98 14.505 6.01 16.044 6.01" />
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M12 3C7.03 3 3 7.03 3 12S7.03 21 12 21 21 16.97 21 12 16.97 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default GetaroundCircleIcon
